module.exports = __webpack_public_path__ + "static/web-white-521f35c8257310d18ab138c8f5691d7f.svg";